import { clearConfig } from "../utils/roleHelper";
import {
  TOKEN_KEY,
  USER_KEY,
  LOGOUT_MSG_KEY,
  ID_AZIENDA_KEY,
  QUERY_CACHE_KEY,
  getUserInfo,
  saveUserInfo,
} from "./storageKeys";

export { TOKEN_KEY, USER_KEY, LOGOUT_MSG_KEY, ID_AZIENDA_KEY, getUserInfo, saveUserInfo };

export function isTokenPresent() {
  const t = localStorage.getItem(TOKEN_KEY);
  return typeof t === "string" && t.trim().length > 0;
}

export function saveLogin({ token, nomeCompleto, email, idAzienda }) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (idAzienda) localStorage.setItem(ID_AZIENDA_KEY, String(idAzienda));
  if (nomeCompleto || email) saveUserInfo({ nomeCompleto: nomeCompleto || "", email: email || "" });
  // Sessione appena aperta senza ricaricare la pagina: il realtime si
  // collega ora (vedi useRealtimeSync).
  window.dispatchEvent(new Event("pr:session"));
}

export function logout(message) {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ID_AZIENDA_KEY);
    clearConfig();
    // Un altro utente sullo stesso browser non deve vedere i dati del precedente.
    localStorage.removeItem(QUERY_CACHE_KEY);
    if (message) localStorage.setItem(LOGOUT_MSG_KEY, message);
  } finally {
    window.location.replace("/Login");
  }
}
